import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MapUtilsGlobalService } from "./http-utils/map-utils-global.service";
import { Constants } from '../models/constants.model';
import { EnvironmentService } from '../service/environments-service/environments-service';
import { Observable, Subscription, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export abstract class ProxyHttpService {

  baseUrl: string;
  envsubscription: Subscription;

  constructor(
    protected http: HttpClient,
    public $e: EnvironmentService
  ) {
    this.envsubscription = this.$e.get().subscribe((environment) => {
      if (environment) {
        this.baseUrl = environment.apiUrl;
        //this.baseUrl = 'https://b2ctest.ecredit.it' //per testare da locale decommentare questa linea
      }
    });
  }

  callServiceWithMultipart(
    serviceId: string, parameters: Object, urlParameters: Map<string, string>, type: any, postParameters?: Map<string, string>, file?: File): Observable<any> {
    return this.requestPostHttpWithFile(serviceId, urlParameters, type, postParameters, file);
  }

  callPlainServiceWithMultipart(
    serviceId: string, parameters: Object, urlParameters: Map<string, string>, type: any, postParameters?: Map<string, string>, file?: File): Observable<any> {
    return this.requestPostHttpWithFile(serviceId, urlParameters, type, postParameters, file, true);
  }

  protected isError(data) {
    let error = true;
    if(data !== null) {
      if(data.returnCodeList===Constants.HttpServer.codeReturn.ServiceOk || data.returnCodeList===Constants.HttpServer.codeReturn.ShowAllErrorMessage) {
        error = false;
      }
    }
    return error;
  }

  private extractData(res: any, type: any) {
    const datas = res.objReturn;
    const code = res.returnCodeList;
    
    const toRet = [];

    if(datas && code === Constants.HttpServer.codeReturn.ServiceOk) {
      if(type !== null) {
        datas.forEach((dataPoint) => toRet.push(MapUtilsGlobalService.deserialize(type, dataPoint)));
        return toRet[0];
      } 
      else {
        return res.json();
      }
    }
    else {
      throw (res.json());
    }

  }

  private extractPlainData(res: any, type: any) {
    const datas = res;
    let toRet = null;
    if(type !== null) {
      toRet = MapUtilsGlobalService.deserialize(type, datas);
      return toRet;
    }
    else {
      return datas;
    }
  }

  private headersManagerMultipart(): HttpHeaders {
    let headers = new HttpHeaders();
    // COMMENTO headers = headers.append("X-TechnicalDataCall-RequestId", "NA");
    // COMMENTO headers = headers.append("X-TechnicalDataCall-CallerReference", "Check-Anag-Data-Quality");
    // COMMENTO headers = headers.append("Content-type", "multipart/form-data");
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Cache-control', 'no-store');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return headers;
  }

  handleError(error: Response | any): Observable<any> {
    // In a real world app, you might use a remote logging infrastructure
    // let errMsg: string;
    // if (error instanceof Response) {
    //   const body = error.json() || '';
    //   const err = body.error || JSON.stringify(body);
    //   errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    // } else {
    //   errMsg = error.message ? error.message : error.toString();
    // }
    return observableThrowError(error);
  }


  requestPostHttpWithFile(
    serviceId: string, urlParameters: Map<string, string>, type: any, postParameters?: Map<string, string>, file?: File, plain = false): Observable<any> {
    const formData = new FormData();
    if(postParameters !== null) {
      postParameters.forEach((value: string, key: string) => {
        formData.append(key, value);
      });
    }
    formData.append("file", file);
    const body = formData;

    let url = Constants.HttpServer.baseApiURL + Constants.HttpServer.API[serviceId];

    let inputUrlParam = '';
    let count = 0;
    if(urlParameters !== null) {
      urlParameters.forEach((value: string, key: string) => {
        if(count > 0) {
          inputUrlParam = inputUrlParam +'&';
        }
        inputUrlParam = `${inputUrlParam + key} = ${value}`;
        count++;
      });
    }
    if(inputUrlParam !== null && inputUrlParam.length>0) {
      url = `${url}?${inputUrlParam}`;
    }

    const headers = this.headersManagerMultipart();

    return this.http.post(url, body, {headers: headers}).pipe(
      map(response => plain ? this.extractPlainData(response, null) : this.extractData(response, null)),
      catchError(this.handleError)
    );
  }

}
